import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

// Unticked by default; one reminder, 7 days after finishing.
export const GlimpseReminderOptIn = ({ reminder, journey }) => {
  const [on, setOn] = useState(!!reminder?.opt_in);
  const [busy, setBusy] = useState(false);
  if (!journey || journey.stage !== "invite" || reminder?.status === "sent") return null;
  const toggle = async (e) => {
    const next = e.target.checked;
    setBusy(true);
    try {
      await api.post("/glimpse/reminder-opt-in", { opt_in: next });
      setOn(next);
      toast.success(next ? "We'll send you one reminder in 7 days" : "Reminder cancelled");
    } catch (x) { toast.error(formatApiError(x.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <label className="cg-card p-6 flex items-start gap-3 text-sm text-[#B9BDC7] cursor-pointer" data-testid="glimpse-reminder-optin">
      <input type="checkbox" checked={on} disabled={busy} onChange={toggle} data-testid="glimpse-reminder-checkbox" className="mt-1 accent-[#D9A25F]" />
      <span>Email me one gentle reminder in 7 days about completing my Authority Portrait.
        <span className="block text-xs text-[#6B7280] mt-1">Optional. Just one email, and no reminder is sent if you continue before then. You can untick this anytime.</span>
      </span>
    </label>
  );
};
